module.exports = __webpack_public_path__ + "static/img/img1.1b0be8df.png";